import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Slide from '@material-ui/core/Slide';

import axios from 'axios'

import EditUser from './EditUser';
import CreateUser from './CreateUser';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog({ opener, closer, token}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [users, setUsers] = React.useState([]);
  const [change, setChange] = React.useState(0);

  useEffect(() => {
    console.log(opener)
    setOpen(opener)
  }, [opener])

  const handleClose = () => {
    closer(false);
  };

  useEffect(() => {
    if(opener) {
      axios.get('https://bakken-admin.herokuapp.com/users', { 
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(resp => {
          setUsers(resp.data)
          console.log(resp.data)
        })
        .catch(err => console.warn(err))
    }
  }, [opener, change])

  return (
    <div>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Administrer brugere
            </Typography>
            <CreateUser token={token} emitChange={() => setChange(i => i + 1)} />
          </Toolbar>
        </AppBar>
        {users.length > 0 &&
        <List>
          {users.map(user => 
          <>
            <ListItem>
              <ListItemText primary={user.email} secondary={user.locations.join(', ')} />
              <ListItemSecondaryAction>
                <EditUser user={user} token={token} emitChange={() => setChange(i => i + 1)} />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            </>
          )}
        </List>}
      </Dialog>
    </div>
  );
}
